import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { Card, CardBody } from "../../../components/card/card";
import { useState } from "react";
import Pagination2 from "../../../components/pagination/pagination2";
import { dashboardMechanicBySpcl } from "../../../config/apiSPA";

const paginationPreset = {
  current_page: "",
  data: [],
  first_page_url: "",
  from: "",
  last_page: "",
  last_page_url: "",
  links: [],
  next_page_url: "",
  path: "",
  per_page: 3,
  prev_page_url: "",
  to: "",
  total: "",
};
function ModalMechanicBySpcl({ show, onHide, spcl }) {
  const [pgState, setPgState] = useState(paginationPreset);
  const [loading, setLoading] = useState(true);
  const [mechData, setMechData] = useState();
  function handlePgNext(val) {
    if (pgState.current_page < pgState.last_page) dashboardMechanicBySpcl(spcl, pgState.current_page + 1).then((res) => showData(res));
  }
  function handlePgPrev(val) {
    if (pgState.current_page > 0) dashboardMechanicBySpcl(spcl, pgState.current_page - 1).then((res) => showData(res));
  }
  function showData({ result: { data } }) {
    setLoading(false);
    setMechData(data.data);
    setPgState(data);
  }
  function onShow() {
    setLoading(true);
    dashboardMechanicBySpcl(spcl, "").then((res) => showData(res));
  }
  return (
    <>
      <Modal size="lg" show={show} onShow={onShow} onHide={() => onHide()}>
        <ModalHeader closeButton>
          <h5 className="modal-title">{spcl + " Specialist Mechanics List"}</h5>
        </ModalHeader>
        <ModalBody>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <Card>
                <CardBody>
                  <>
                    <div className="table-responsive">
                      <table className="table table-hover text-nowrap">
                        <thead>
                          <tr>
                            <th className="border-top-0 pt-0 pb-2">NRP</th>
                            <th className="border-top-0 pt-0 pb-2">Name</th>
                            <th className="border-top-0 pt-0 pb-2">Position</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mechData.length > 0 ? (
                            <>
                              {mechData.map((val, index) => (
                                <tr key={index}>
                                  <td className="align-middle">{val.nrp}</td>
                                  <td className="align-middle">{val.nama}</td>
                                  <td className="align-middle">{val.subSection}</td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <td className="align-middle">No Data</td>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <Pagination2 pageInfo={pgState} nextClick={handlePgNext} prevClick={handlePgPrev} />
                  </>
                </CardBody>
              </Card>
            </>
          )}
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
    </>
  );
}

export default ModalMechanicBySpcl;
